__turbopack_context__.v({
  "action": "TX691q_action",
  "call-to-action": "TX691q_call-to-action",
});
